module.exports = __webpack_public_path__ + "img/sable_default.94b8c0e5.svg";